import { BaseEntity } from 'src/app/tools/models/baseEntity';


export class ProductAnalysisGroup4 extends BaseEntity {

  productAnalysisGroup4Code : string;
  name                      : string;
  rank                      : string;
   
}